export const WORKER_STUCK_ATTENDANCE_MESSAGE = 'Attendance issue — contact office';

export const getWorkerShiftAttendanceStatusFromItem = (item) => item?.current_attendance?.status || null;

export const isWorkerAssignmentActiveAccepted = (item) => {
  const assignmentStatus = item?.assignment_status || item?.assignment?.status;
  const workerResponseStatus = item?.worker_response_status || item?.assignment?.worker_response_status || 'pending';
  return assignmentStatus === 'active' && workerResponseStatus === 'accepted';
};

export const hasWorkerStuckOpenAttendance = (item) => (
  getWorkerShiftAttendanceStatusFromItem(item) === 'open' && !isWorkerAssignmentActiveAccepted(item)
);

export const getWorkerRejectedAttendanceCardLabel = (attendance) => {
  if (!attendance || attendance.status !== 'rejected') return 'Resubmission required';
  const resolution = attendance.rejection_resolution;
  if (resolution === 'admin_correction_required') return 'Being corrected by your care provider';
  if (resolution === 'escalated') return 'Under office review';
  return 'Resubmission required';
};

export const isWorkerShiftPast = (shift) => {
  if (!shift?.end_at) return false;
  const endMs = new Date(shift.end_at).getTime();
  return !Number.isNaN(endMs) && endMs < Date.now();
};

export const getWorkerShiftListCategory = (item) => {
  const shift = item?.shift || {};
  const responseStatus = item?.worker_response_status || item?.assignment?.worker_response_status || 'pending';
  const assignmentStatus = item?.assignment_status || item?.assignment?.status || 'active';
  const attendanceStatus = getWorkerShiftAttendanceStatusFromItem(item);
  const shiftStatus = shift?.status;
  const past = isWorkerShiftPast(shift);

  if (assignmentStatus === 'active' && (responseStatus === 'pending' || !responseStatus)) {
    return 'pending_offer';
  }

  if (assignmentStatus === 'active' && attendanceStatus === 'rejected') {
    return 'active';
  }

  if (hasWorkerStuckOpenAttendance(item)) {
    return 'active';
  }

  if (attendanceStatus === 'open' || (attendanceStatus === 'submitted' && !past)) {
    return 'active';
  }

  if (attendanceStatus === 'submitted' && past) {
    return 'history';
  }

  if (past) {
    if (
      attendanceStatus === 'approved' ||
      assignmentStatus === 'completed' ||
      shiftStatus === 'completed' ||
      assignmentStatus === 'cancelled' ||
      shiftStatus === 'cancelled'
    ) {
      return 'history';
    }
    if (responseStatus === 'accepted' && !attendanceStatus) {
      return 'history';
    }
  }

  if (!past) {
    return 'active';
  }

  return 'history';
};

export const workerMayResubmitRejectedAttendance = (attendance) => {
  if (!attendance || attendance.status !== 'rejected') return false;
  const resolution = attendance.rejection_resolution;
  if (!resolution) return true;
  return resolution === 'worker_resubmit';
};

export const getWorkerRejectedAttendanceMessage = (attendance) => {
  if (!attendance || attendance.status !== 'rejected') return null;
  if (attendance.rejection_resolution === 'admin_correction_required') {
    return 'Attendance is being corrected by your care provider — contact office if needed.';
  }
  if (attendance.rejection_resolution === 'escalated') {
    return 'Attendance under review.';
  }
  return 'Resubmission required — tap Re-submit or open shift';
};

export const canWorkerEditDailyNoteForItem = (item) => {
  const attendanceStatus = getWorkerShiftAttendanceStatusFromItem(item);
  const shift = item?.shift || {};
  const requiresDailyNote = Boolean(shift.service_user_id || shift.service_user?.id);
  if (!requiresDailyNote) return false;
  if (item?.current_daily_note) return false;
  // Do not show a care-record form before the visit starts. A submitted
  // attendance may still receive a traceable late entry until admin approval.
  return attendanceStatus === 'open' || attendanceStatus === 'submitted';
};
